import { render, staticRenderFns } from "./eyeDiseaseHome.vue?vue&type=template&id=4a6cb0d0&scoped=true&"
import script from "./eyeDiseaseHome.vue?vue&type=script&lang=js&"
export * from "./eyeDiseaseHome.vue?vue&type=script&lang=js&"
import style0 from "./eyeDiseaseHome.vue?vue&type=style&index=0&id=4a6cb0d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cb0d0",
  null
  
)

export default component.exports